module.exports = __webpack_public_path__ + "img/K65S30.3c2647f7.jpg";